import { appConstantUrl } from 'appConstant';
import { INVALIDATE_BUTTON_ACTION } from './types';
import { callAPI } from 'Action';

export const getInvalidateAction =
  (value: any, Invalidate: any = undefined) =>
  async (dispatch: any) => {
    let url = appConstantUrl.changeStatusUrl;
    let reqObj = value;
    if (typeof Invalidate != 'object') {
      url += `?Status=${Invalidate}`;
    } else {
      return;
    }
    const options = {
      url,
      method: 'POST',
      actionType: INVALIDATE_BUTTON_ACTION,
      dispatch,
      reqObj,
    };
    let invalidateAction = await callAPI(options);
    if (invalidateAction) {
      dispatch({
        type: INVALIDATE_BUTTON_ACTION,
        payload: invalidateAction.data,
      });
    }
    return invalidateAction;
  };
